import { v4 } from 'uuid';

export function addListIdToObjectList<ListItem extends { listId?: string }>(
  items: ListItem[],
): (ListItem & { listId: string })[] {
  return items.map((item) => ({
    ...item,
    listId: item.listId || v4(),
  }));
}
